/**
 * The addresses in an email header value such as From or Cc.
 * Quoted display names are dropped first, as they may hold commas: `"Doe, John" <john@example.com>`
 */
export function emailAddresses(value?: string) {
  return (value || ``)
    .replace(/"[^"]*"/g, ``)
    .split(`,`)
    .map(part => (part.match(/<([^>]+)>/)?.[1] || part).trim())
    .filter(part => part.includes(`@`));
}
